module.exports = __webpack_public_path__ + "fonts/icons.ee1d2db7.ttf";